import { logger } from '@lessonup/logging-classic';
import { LanguageKey, LanguageSingleton } from '@lessonup/typescript-core/domain';
import { Footer, FooterType, LanguageSwitch } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useAppServices } from '../appServices/AppServicesContext';

interface Props {
  footerType: FooterType;
  children?: React.ReactNode;
}

export const FooterWithLanguageSwitch: React.FC<Props> = ({ footerType, children }) => {
  const services = useAppServices();

  async function handleLanguageChange(lang: LanguageKey) {
    try {
      await services.user.setLanguage(lang);
    } catch (error) {
      logger.error(error);
    }
  }

  const Picker = (
    <LanguageSwitch
      expandDirection="top"
      handleLanguageChange={handleLanguageChange}
      className="language-switch-navbar"
      currentLanguage={LanguageSingleton.get()}
    />
  );

  return (
    <Footer footerType={footerType} slotRight={Picker}>
      {children}
    </Footer>
  );
};
